// A bill is "Credit" only when it is really billed on credit: a credit payment mode was chosen (a sponsor / panel
// credit), or a B2B party is billed and nothing was collected. A walk-in who simply has not paid yet is unpaid, not
// credit: they settle later at the counter and a receipt is issued then.
export const CREDIT_PAYMENT_MODES = ['Credit', 'Credit / Panel Sponsor'];

export const isCreditBill = ({ payments = [], partyId = null, remainingBalance = 0 } = {}) => {
  const chosenCredit = payments.some((p) => CREDIT_PAYMENT_MODES.includes(p?.paymentMode));
  const billedToParty = !!partyId && payments.length === 0 && remainingBalance > 0;
  return chosenCredit || billedToParty;
};
